const skelton = require('./DefaultSystemConfigFrontendData.json')

function convertBackToFront (backendData) {
  const parsedData = JSON.parse(JSON.parse(backendData.config))
  const eachAddresData = JSON.parse(JSON.stringify(skelton))
  parsedData['refregerant'].forEach(systemConfig => {
    const target = eachAddresData[systemConfig.Address]
    if (systemConfig.OC === 0) {
      target.oc = true
    } else if (systemConfig.OC === 1) {
      target.oc = true
      target.oc_adp1 = true
    } else if (systemConfig.OC === 2) {
      target.oc = true
      target.oc_adp1 = true
      target.oc_adp2 = true
    }
    if (systemConfig.IC.length >= 1) {
      target.ic1 = true
      if (systemConfig.IC[0] === 1) {
        target.ic1_adp1 = true
      } else if (systemConfig.IC[0] === 2) {
        target.ic1_adp1 = true
        target.ic1_adp2 = true
      }
    }
    if (systemConfig.IC.length >= 2) {
      target.ic2 = true
      if (systemConfig.IC[1] === 1) {
        target.ic2_adp1 = true
      } else if (systemConfig.IC[1] === 2) {
        target.ic2_adp1 = true
        target.ic2_adp2 = true
      }
    }
    if (systemConfig.IC.length >= 3) {
      target.ic3 = true
      if (systemConfig.IC[2] === 1) {
        target.ic3_adp1 = true
      } else if (systemConfig.IC[2] === 2) {
        target.ic3_adp1 = true
        target.ic3_adp2 = true
      }
    }
    if (systemConfig.IC.length >= 4) {
      target.ic4 = true
      if (systemConfig.IC[3] === 1) {
        target.ic4_adp1 = true
      } else if (systemConfig.IC[3] === 2) {
        target.ic4_adp1 = true
        target.ic4_adp2 = true
      }
    }
  })
  parsedData['controller'].forEach(systemConfig => {
    const target = eachAddresData[systemConfig.Address]
    target.rc = true
  })
  return eachAddresData
}

module.exports = convertBackToFront
